<template>
  <div>
    <div>
      <highcharts ref="graphContainer" class="ranking-regentes-graph" :options="packedbubbleOptions" :redraw="true"></highcharts>
    </div>
  </div>
</template>

<style lang="scss">
  .ranking-regentes-graph {
    width: 100%;
    height: 620px;
  }
</style>


<script>

  import { Chart } from 'highcharts-vue'
  import Highcharts from "highcharts"
  import more from 'highcharts/highcharts-more'
  import streamgraph from 'highcharts/modules/streamgraph'

  more(Highcharts)
  streamgraph(Highcharts)

  export default {
    name: 'RegenteGraph',
    props: {
      nData: {
        type: Object,
        default() { return }
      },
    },
    components: {
      highcharts: Chart
    },
    watch: {
      nData(value) {
        //setting up new data
        this.$refs['graphContainer'].chart.series[0].setData(value, true)
      }
    },
    computed: {
      dataUpdate() {
        return [this.nData]
      },
      packedbubbleOptions() {
        return {
          chart: {
            type: 'bar'
          },
          title: {
              text: ''
          },
          xAxis: {
            labels: {
              enabled: false
            }
          },
          yAxis: {
            min: 0,
            title: {
              text: 'PMF aprobados'
            }
          },
          legend: {
            enabled: false
          },
          credits: {
            enabled: false
          },
          tooltip: {
              headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat: '<tr><td style="padding:0">Planes: </td>' +
                  '<td style="padding:0"><b>{point.y}</b></td></tr><tr><td style="padding:0"></b></td></tr>',
              footerFormat: '</table>',
              shared: true,
              useHTML: true,
              enabled: false
          },
          plotOptions: {
            series: {
              dataLabels: {
                pointFormat: '<span class="label-graph-ranking">{point.name} ({point.y} PMF)</span>',
                align: 'left',
                enabled: true,
                useHTML: true
              },
              pointPadding: 0,
              groupPadding: 0.1
            }
          },
          series: this.dataUpdate
      }
    }
  }
}
</script>